import React from 'react';
import { Repeat, Check, Leaf, Award, ShieldCheck } from 'lucide-react';
type ProductFeatureProps = {
  title: string;
  description: string;
  icon: 'Repeat' | 'Check' | 'Leaf' | 'Award' | 'ShieldCheck';
};
export function ProductFeature({
  title,
  description,
  icon
}: ProductFeatureProps) {
  const getIcon = () => {
    switch (icon) {
      case 'Repeat':
        return <Repeat size={24} className="text-blue-500" data-id="element-243" />;
      case 'Check':
        return <Check size={24} className="text-blue-500" data-id="element-244" />;
      case 'Leaf':
        return <Leaf size={24} className="text-blue-500" data-id="element-245" />;
      case 'Award':
        return <Award size={24} className="text-blue-500" data-id="element-246" />;
      case 'ShieldCheck':
        return <ShieldCheck size={24} className="text-blue-500" data-id="element-247" />;
      default:
        return null;
    }
  };
  return <div className="flex" data-id="element-248">
      <div className="mr-3 flex-shrink-0" data-id="element-249">{getIcon()}</div>
      <div data-id="element-250">
        <h3 className="font-medium mb-1" data-id="element-251">{title}</h3>
        <p className="text-gray-600 text-sm" data-id="element-252">{description}</p>
      </div>
    </div>;
}